import { constant } from "fp-ts/function"

export const constZero = constant(0 as const)

export const constOne = constant(1 as const)

// ts-prune-ignore-next
export const constEmpty = constant("" as const)
